if (!customElements.get('solid-video-hero')) {
 customElements.define('solid-video-hero', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const { signal } = this.abort;
   const videos = [...this.querySelectorAll('video')];
   const button = this.querySelector('[data-hero-toggle]');
   if (!videos.length || !button) return;
   const reduced = matchMedia('(prefers-reduced-motion: reduce)');
   const mobile = matchMedia('(max-width: 749px)');
   let paused = reduced.matches || Boolean(navigator.connection?.saveData), inView = false, active;
   let posterReady = false;
   const updateButton = () => {
    const playing = active && !active.paused;
    button.setAttribute('aria-label', playing ? 'Video pauzeren' : 'Video afspelen');
    button.querySelector('span').textContent = playing ? 'Ⅱ' : '▷';
   };
   const sync = () => {
    active = mobile.matches ? this.querySelector('.solid-video-hero-film--mobile') || videos[0] : this.querySelector('.solid-video-hero-film--desktop') || videos[0];
    videos.forEach(video => {
     if (video !== active) { video.pause(); video.classList.remove('is-visible'); }
    });
    if (!posterReady || paused || !inView || document.hidden) active.pause();
    else active.play().catch(() => { updateButton(); });
    updateButton();
   };
   videos.forEach(video => {
    video.muted = true;
    video.addEventListener('playing', () => { video.classList.add('is-visible'); updateButton(); }, { signal });
    video.addEventListener('pause', updateButton, { signal });
    video.addEventListener('error', () => { video.classList.remove('is-visible'); updateButton(); }, { signal });
   });
   button.hidden = false;
   button.addEventListener('click', () => {
    paused = active ? !active.paused : false;
    posterReady = true;
    sync();
   }, { signal });
   reduced.addEventListener('change', () => { paused = reduced.matches; sync(); }, { signal });
   mobile.addEventListener('change', sync, { signal });
   document.addEventListener('visibilitychange', sync, { signal });
   this.observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; sync(); }, { threshold: .1 });
   this.observer.observe(this);
   sync();
   // Let the high-priority poster paint before video competes for bandwidth.
   const poster = this.querySelector('.solid-video-hero-poster');
   const ready = poster?.decode ? poster.decode().catch(() => {}) : Promise.resolve();
   const pageReady = document.readyState === 'complete' ? Promise.resolve() : new Promise(resolve => {
    window.addEventListener('load', resolve, { once: true, signal });
   });
   Promise.all([ready, pageReady]).then(() => requestAnimationFrame(() => requestAnimationFrame(() => {
    if (signal.aborted) return;
    posterReady = true;
    sync();
   })));
  }
  disconnectedCallback() {
   this.abort?.abort();
   this.observer?.disconnect();
   this.querySelectorAll('video').forEach(video => video.pause());
  }
 });
}
